/**
 * 
 * @param {Array} menuTutorial 
 * @param {String} denominacionTutorial 
 * @returns Devuelve todos elementos que tengan la misma Denominacion
 */
export const BuscarTutorialByDenominacion = (menuTutorial, denominacionTutorial) => {
   if (menuTutorial) {
      let ArrEncontrados = [];

      for (const itemMenuTutorial of menuTutorial) {
         if (denominacionTutorial === itemMenuTutorial.denominacion) {
            const itemMenuTutorialInfo = {
               codigo: itemMenuTutorial.codigo,
               denominacion: itemMenuTutorial.denominacion,
               descripcion: itemMenuTutorial.descripcion,
               observaciones: itemMenuTutorial.observaciones,
               url: itemMenuTutorial.url
            };
            ArrEncontrados.push(itemMenuTutorialInfo);
         }

         if (itemMenuTutorial.hijos !== undefined) {
            // Realiza la búsqueda en los hijos, pero no devuelve inmediatamente.
            const resultadoHijos = BuscarTutorialByDenominacion(
               itemMenuTutorial.hijos,
               denominacionTutorial
            );

            if (resultadoHijos) {
               // Si se encontró un código en los hijos, actualiza el último código encontrado.
               ArrEncontrados = ArrEncontrados.concat(resultadoHijos);
            }
         }
      }

      return ArrEncontrados;
   }
   return [];
};
